import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from './components/Layout';
import ResponsiveShadow from './components/ResponsiveShadow';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import TableContainer from './components/TableContainer';
import TableHeader from './components/TableHeader';
import Pagination10 from './components/Pagination10';
import PageFooter from './components/PageFooter';
import usePagination10 from './components/hooks/usePagination10';
import axios from 'axios';
import { Alert } from 'react-bootstrap';
import { API_BASE_URL } from '../config/ApiConfig';
import MarginsConfigModal from './components/modalServices/MarginsConfigModal';

export default function MarginsList() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const token = localStorage.getItem('token');
  const appCliente = JSON.parse(localStorage.getItem('appCliente') || '{}');
  const navigate = useNavigate();

  const fetchRows = async (ensureDefaults = true) => {
    setLoading(true);
    try {
      const cnpj = appCliente?.cnpj || localStorage.getItem('cnpj');
      if (!cnpj) {
        // sem CNPJ selecionado: mostrar defaults e aviso
        const defaults = [
          { cnpj: localStorage.getItem('cnpj') || '', orientacao: 'P', top: 2552, bottom: 1134, left: 851, right: 851 },
          { cnpj: localStorage.getItem('cnpj') || '', orientacao: 'R', top: 2552, bottom: 1418, left: 1134, right: 851 },
        ];
        setRows(defaults);
        setNeedSelectEntity(true);
        return;
      }
      const res = await axios.get(`${API_BASE_URL.APP_MARGINS}/list/${encodeURIComponent(cnpj)}`, { headers: { Authorization: `Bearer ${token}` } });
      let data = res.data || [];
      // garantir que existam as duas orientações (P e R)
      if (ensureDefaults) {
        const hasP = data.some(d => d.orientacao === 'P');
        const hasR = data.some(d => d.orientacao === 'R');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const toCreate = [];
        if (!hasP) toCreate.push({ cnpj, orientacao: 'P', top: 2552, bottom: 1134, left: 851, right: 851 });
        if (!hasR) toCreate.push({ cnpj, orientacao: 'R', top: 2552, bottom: 1418, left: 1134, right: 851 });
        if (toCreate.length > 0) {
          // criar registros faltantes
          await Promise.all(toCreate.map(p => axios.post(`${API_BASE_URL.APP_MARGINS}/save`, p, { headers })));
          // buscar novamente os registros criados e atualizar a lista (evita recursão com finally)
          const res2 = await axios.get(`${API_BASE_URL.APP_MARGINS}/list/${encodeURIComponent(cnpj)}`, { headers });
          data = res2.data || [];
          setRows(data.length ? data : [
            { cnpj, orientacao: 'P', top: 2552, bottom: 1134, left: 851, right: 851 },
            { cnpj, orientacao: 'R', top: 2552, bottom: 1418, left: 1134, right: 851 },
          ]);
          setNeedSelectEntity(false);
          return;
        }
      }
      setRows(data.length ? data : [
        { cnpj, orientacao: 'P', top: 2552, bottom: 1134, left: 851, right: 851 },
        { cnpj, orientacao: 'R', top: 2552, bottom: 1418, left: 1134, right: 851 },
      ]);
      setNeedSelectEntity(false);
    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRows();
  }, []);

  const [needSelectEntity, setNeedSelectEntity] = useState(false);

  const totalItems = rows.length;
  const { setPagination } = usePagination10(totalItems);
  const { startIndex, rowsPerPage } = setPagination;
  const displayedRows = rows.slice(startIndex, startIndex + rowsPerPage);

  const orientacaoDescricao = (o) => {
    if (!o) return '';
    const s = o.toString().toUpperCase();
    return s === 'P' ? 'Paisagem' : s === 'R' ? 'Retrato' : o;
  };

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Configurações de Margens de Documentos" icon="bi-rulers" closeRoute="/home" backButton={false} />
        <PageContent>
      {needSelectEntity && (
        <Alert variant="warning">Selecione uma entidade em <strong>Seleciona Entidade</strong> para salvar alterações.</Alert>
      )}
      <TableContainer tableClass="table-custom-radius">
        <TableHeader columns={[
          { label: 'Orientação' },
          { label: 'Topo (cm)' },
          { label: 'Inferior (cm)' },
          { label: 'Esquerda (cm)' },
          { label: 'Direita (cm)' },
          { label: '' },
        ]} />
        <tbody>
          {displayedRows.map(r => (
            <tr key={r.orientacao}>
              <td>{orientacaoDescricao(r.orientacao)}</td>
              <td>{(r.top/567).toFixed(2).replace('.', ',')}</td>
              <td>{(r.bottom/567).toFixed(2).replace('.', ',')}</td>
              <td>{(r.left/567).toFixed(2).replace('.', ',')}</td>
              <td>{(r.right/567).toFixed(2).replace('.', ',')}</td>
              <td>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => { setEditing({ ...r, cnpj: appCliente?.cnpj || localStorage.getItem('cnpj') }); setModalOpen(true); }}
                  disabled={!appCliente?.cnpj}
                  title={!appCliente?.cnpj ? 'CNPJ não selecionado' : ''}
                >
                  Editar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </TableContainer>
      <MarginsConfigModal isOpen={modalOpen} onClose={()=>{ setModalOpen(false); setEditing(null); fetchRows(); }} initial={editing || { cnpj: appCliente?.cnpj, orientacao: 'P' }} onSaved={fetchRows} />
        </PageContent>
        <PageFooter style={{ marginTop: '0.5rem' }}>
        <Pagination10 {...setPagination} />
      </PageFooter>
      </ResponsiveShadow>
    </Layout>
  );
}
